import React from "react";
import { useNavigate } from "react-router-dom";
import MainMenuItem from "app/components/MainMenuItem";
import Path from "app/route/Path";

function SharedInfoLevelMenuItem(props) {
  const navigate = useNavigate();

  const onMenuItemClicked = () => {
    navigate(Path.systemSetting.sharedInfoLevel);
  };

  return (
    <MainMenuItem
      itemTitleString="情報共有レベルを設定"
      onClick={onMenuItemClicked}
      size="100%"
    />
  );
}

export default SharedInfoLevelMenuItem;
